import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { WIDGET_ICONS } from "../../../../constants";
import ImageRadio from "../../../../parts/inputs/image-radio";
import ModalFooter from "../../../../parts/modals/ModalFooter";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";

const WIDGET_TYPE_LABEL_KEYS = {
  recipe: "widgets.widgetTypes.recipes",
  "video-playlist": "widgets.widgetTypes.videos",
  "macro-calculator": "widgets.widgetTypes.macroCalculator",
  store: "widgets.widgetTypes.ecommerce",
  "file-documents": "widgets.widgetTypes.filesAndDocuments",
  links: "widgets.widgetTypes.urlLinks",
  "meal-plan-library": "widgets.widgetTypes.mealPlanLibrary",
  "daily-accountability-template":
    "widgets.widgetTypes.dailyAccountabilityTemplates",
};

export const InstallWidgetModal = ({ query }) => {
  const { t } = useTranslation("coaching-portal");
  const { widgetModal } = query; //query to verify the type of the widget

  //state to control the information of the new widget
  const [formState, setFormState] = useState({
    name: "",
    description: "",
    type: widgetModal.type,
    icon:
      widgetModal.type === "recipe"
        ? "utensils"
        : widgetModal.type === "video-playlist"
        ? "desktop"
        : widgetModal.type === "store"
        ? "bag"
        : widgetModal.type === "links"
        ? "attachment"
        : widgetModal.type === "file-documents"
        ? "document-alt"
        : "calculator",
  });

  const { name, description, type, icon } = formState;

  /**
   * Create new widget
   * @param {*} e
   */
  const handleSubmit = (e) => {
    e.preventDefault();
    submit(`/actions/widgets/save`, {
      method: "POST",
      body: formState,
    });
  };

  /**
   *  Assing the values to the state
   * @param {*} param0
   */
  const handleChange = ({ target }) => {
    const newState = Object.assign({}, formState, {
      [target.name]: target.value,
    });
    setFormState(newState);
  };

  /**
   * Validate if the form is valid
   * @returns
   */
  const validateState = () => {
    if (
      name.length > 0 &&
      description.length > 0 &&
      type.length > 0 &&
      icon.length > 0
    ) {
      return true;
    }
    return false;
  };

  const typeLabel =
    WIDGET_TYPE_LABEL_KEYS[widgetModal.type] != null
      ? t(WIDGET_TYPE_LABEL_KEYS[widgetModal.type])
      : widgetModal.type.split("-")[0];
  return (
    <form onSubmit={handleSubmit}>
      <Modal
        className="Widget-Modal"
        title={t("widgets.installModal.title", { type: typeLabel })}
      >
        <div className="body">
          <div>
            <div className="input-group">
              <label className="label req" htmlFor="name">
                {t("widgets.installModal.widgetName")}
              </label>
              <input
                name="name"
                type="text"
                className="text-input"
                onChange={handleChange}
                value={name}
                maxLength="30"
                required
                sz="large"
              />
            </div>
            <div className="input-group">
              <label className="label req" htmlFor="description">
                {t("widgets.installModal.widgetDescription")}
              </label>
              <input
                name="description"
                type="text"
                className="text-input"
                onChange={handleChange}
                value={description}
                maxLength="60"
                required
                sz="large"
              />
            </div>
            <div className="input-group">
              <ImageRadio
                label={t("widgets.installModal.widgetIcon")}
                name="icon"
                currentValue={icon}
                radios={WIDGET_ICONS[type]}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <ModalFooter
          isSubmitButton
          showAltButton={false}
          onClickButton={handleSubmit}
          classNameButton={`button ${
            validateState() ? "save" : "alt-disabled"
          }`}
        />
      </Modal>
    </form>
  );
};
